import { styled } from "../../Theme";

export const QuizContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding: 5%;
  box-sizing: border-box;
`;

export const SectionDescription = styled.div`
  display: flex;
  justify-content: column;
  color: ${props => props.theme.color.text};
  align-items: center;
  margin: 1em;
`;

export const QuizResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const QuizMainResourcesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 5%;
  margin-right: 5%;
  justify-content: center;
  max-width: 90%;
`;

export const QuizSecondaryResourcesContainer = styled.div`
  margin-left: 5%;
  margin-right: 5%;
  margin-bottom: 1em;
`;

export const QuizTitle = styled.h2`
  color: ${props => props.theme.color.primary};
  hyphens: auto;
`;

export const ShowAllContainer = styled.div`
  margin-left: 5%;
  margin-right: 5%;
  align-self: flex-end;
  display: flex;
  color: ${props => props.theme.color.text};
  align-items: center;
`;

export const SwitchLabel = styled.div`
  margin-right: 1em;
  font-weight: bold;
`;
